export enum NewsStatus {
    Seen = 1,
    Read = 2,
    Deleted = 3,
}
